import { useState, useEffect, useCallback } from 'react';
import { fetchParticipacion } from '../services/reportesV2.services';

// Hook: Participación por máquina (nominal + abortados)
export const useParticipacion = ({ idLavanderia, dateRange, enabled = true }) => {
  const [data, setData] = useState({ lotes: [], cycles: [] });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const load = useCallback(async () => {
    if (!enabled || !idLavanderia || !dateRange) return;
    setLoading(true);
    setError(null);
    try {
      const result = await fetchParticipacion({ idLavanderia, dateRange });
      setData(result);
    } catch (e) {
      setError(e.message || 'Error al cargar participación');
    } finally {
      setLoading(false);
    }
  }, [idLavanderia, dateRange, enabled]);

  useEffect(() => {
    load();
  }, [load]);

  return { data, loading, error, reload: load };
};
